import React from 'react';
import { Link } from 'components/navigation/Link/Link';
import './DebtAnalysisLink.scss';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import DifferentialText from 'components/DifferentialText/index';
import {
  getDebtAnalysisDisplayConfig,
  getWhatsChanged,
} from 'helpers/credit_info';
import PIcon from 'components/personalization/PIcon';

const DebtAnalysisDetail = ({
  datatestid,
  data,
  difference,
  description,
  prefix,
  postfix,
  isPositive,
}) => {
  const { dataDisplay, diffDisplay } = getDebtAnalysisDisplayConfig(
    prefix,
    postfix,
    data,
    difference,
  );
  return (
    <FlexContainer className="flex-column align-self-center m-margB16">
      <Label
        datatestid={`${datatestid}-title`}
        type="Body-2"
        className="margB4 fontGray300 m-text-12"
      >
        {description}
      </Label>
      <FlexContainer className="mob-flex-column">
        <Label datatestid={`${datatestid}-value`} type="H4 m-text-20">
          {dataDisplay}
        </Label>
        <div className="padR8 m-padR0" />
        {diffDisplay && (
          <DifferentialText
            datatestid={`${datatestid}-diff`}
            fontSizeClass={'text-16 m-text-14 noWrap bold'}
            display={diffDisplay}
            difference={difference}
            isPositive={isPositive}
            prefix={'$'}
          />
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

function DebtAnalysisLink({
  datatestid,
  onLinkClickCallback,
  link,
  module,
  creditInfo,
  modulePosition,
  ...props
}) {
  const debtAnalysisState = getWhatsChanged(creditInfo, false, true);
  const { debtToIncome, monthlyPayments, totalBalances } = debtAnalysisState;
  return (
    <>
      <Label type="H3 mH5 margB12 m-margB16">{props.titleText}</Label>
      <Link
        to="/factors/accountMix"
        className="factorpagelink-container-debt"
        onClickCallback={onLinkClickCallback}
        location={link}
        module={module}
        extraEventAttributes={{
          'Module Position': modulePosition,
        }}
      >
        <FlexContainer className="factorPageBoxDebt padTB24 padLR24 m-padT16 m-padB0">
          <FlexContainer className="factorBoxLeft justify-between mobileCol-desktopRow m-flex-wrap">
            <DebtAnalysisDetail
              datatestid={`${datatestid}-totalBalances`}
              description={props.debtTitleText}
              prefix={'$'}
              data={totalBalances.current}
              difference={totalBalances.difference}
              isPositive={totalBalances.isPositive}
            />
            <DebtAnalysisDetail
              datatestid={`${datatestid}-monthlyPayments`}
              description={props.monthlyPaymentTitleText}
              prefix={'$'}
              data={monthlyPayments.current}
              difference={monthlyPayments.difference}
              isPositive={monthlyPayments.isPositive}
            />
            <DebtAnalysisDetail
              datatestid={`${datatestid}-DTI`}
              description={props.debtToIncomeRatioTitleText}
              postfix={'%'}
              data={debtToIncome.current}
              difference={debtToIncome.difference}
              isPositive={debtToIncome.isPositive}
            />
          </FlexContainer>
          <FlexContainer className="factorLinkRight justify-end m-hide">
            <div
              className="factorpagelink-right align-self-center"
              data-testid={datatestid ? `${datatestid}-back` : null}
            >
              <PIcon
                icon={props.icons.rightPointingArrow}
                className="arrowRightStyle"
              />
            </div>
          </FlexContainer>
        </FlexContainer>
      </Link>
    </>
  );
}

export { DebtAnalysisLink };
